import { fetchApi } from '@/config/axiosSetting';

import {
  IBodyVisitInformationResponseType,
  IBodyVisitInformationTypeParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVisitInformation/getBodyVisitInformationQuer.type';

export const getBodyVisitInformationQueryFunction = (
  params: IBodyVisitInformationTypeParams,
): Promise<IBodyVisitInformationResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/adjusting/visit_information/`,
    {
      params: {
        id: params.id,
        source: params.source,
      },
    },
  );
};
